import { useSelector } from 'react-redux'
import { selectAuthData } from '@/containers/Login/AuthSelectors'

const useRightPanelRedesign = (): boolean =>
  useSelector(selectAuthData)?.commonData?.rightPanelRedesignEnabled === true

export default useRightPanelRedesign
